import { useQuery } from "@tanstack/react-query";
import { api } from "../api";
import { Layout } from "../components/Layout";
import { useReveal } from "../useReveal";

function farkEtiket(diff) {
  if (diff === null || diff === undefined) return null;
  if (diff > 0) return <span className="karne-fark erken">▸ {diff} ay erken</span>;
  if (diff < 0) return <span className="karne-fark gec">▸ {Math.abs(diff)} ay gecikme</span>;
  return <span className="karne-fark tam">▸ tam zamanında</span>;
}

export default function TeslimKarnesi() {
  const { data, isLoading } = useQuery({
    queryKey: ["delivery-report"], queryFn: async () => (await api.get("/delivery-report")).data,
  });
  useReveal(!isLoading);
  const ort = data?.average_diff ?? 0;
  const ortMetin = ort > 0 ? `${ort} ay erken` : ort < 0 ? `${Math.abs(ort)} ay gecikme` : "tam zamanında";

  return (
    <Layout>
      <section className="sayfa-basi">
        <div className="karne">
          <div className="veri bel">Teslim Karnesi</div>
          <h1 className="h-dev bel" style={{ margin: "14px 0 20px" }}>Söz verdiğimiz tarih. Teslim ettiğimiz tarih.</h1>
          <p className="bel" style={{ color: "var(--metin-2)", maxWidth: "52ch", marginBottom: 20 }}>
            Gizlenecek bir şey yok. Erken bitirdiğimizde de, geciktiğimizde de nedeniyle birlikte yazıyoruz.
          </p>

          {isLoading ? <p className="veri">Yükleniyor…</p> : (
            <>
              {(data?.projects || []).map((p) => (
                <div className="karne-satir bel" key={p.slug} data-testid={`karne-${p.slug}`}>
                  <div className="karne-ad">{p.name}</div>
                  <div className="karne-tarihler">
                    <div className="karne-tarih">
                      <div className="veri">Söz verilen teslim</div>
                      <b>{p.promised_label}</b>
                    </div>
                    <div>{farkEtiket(p.diff)}</div>
                    <div className="karne-tarih">
                      <div className="veri">Gerçekleşen teslim</div>
                      <b>{p.actual_label}</b>
                    </div>
                  </div>
                  {p.delay_note && <p className="karne-not">{p.delay_note}</p>}
                </div>
              ))}
              <div className="karne-ozet bel">
                <p className="veri" style={{ marginBottom: 12 }}>{data?.count} projede ortalama teslim farkı</p>
                <span className="h-orta"><b>{ortMetin}</b></span>
              </div>
            </>
          )}
        </div>
      </section>
    </Layout>
  );
}
